import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import api from '../api/client';
import './Team.css';

const TODAY = new Date().toISOString().split('T')[0];
const STORAGE_KEY = 'ryzenos_team';

const INIT_MEMBERS = [
  { id:1, name:'Yadhu Krishna', role:'Admin', dept:'Management', phone:'', email:'', avatar:'YK', performance:0, status:'present', leaveBalance:12, joinDate:new Date().toISOString().split('T')[0], tasks:{done:0,total:0}, username:'Yadhu05', password:'Ryzen0705', userRole:'Admin' },
  { id:2, name:'Sanjog', role:'Team Member', dept:'Ops', phone:'', email:'', avatar:'S', performance:0, status:'present', leaveBalance:12, joinDate:new Date().toISOString().split('T')[0], tasks:{done:0,total:0}, username:'Sanjogj', password:'Ryzen0705', userRole:'User' },
];

const DEPTS = ['All','Sales','Ops','Finance','Mktg','Tech','HR','Design','Support','Product','Management'];
const ROLE_SUGGESTIONS = ['Sales Lead','Sales Executive','Business Development Executive','Ops Manager','Finance Analyst','Accounts Executive','Marketing Executive','Social Media Manager','Content Writer','HR Executive','Dev Engineer','Frontend Developer','Backend Developer','Full Stack Developer','QA Tester','UI/UX Designer','Project Manager','Customer Support Executive'];
const USER_ROLES = ['Super Admin','Admin','User'];
const perfColor = p => p>=80?'#22C55E':p>=65?'#F5A623':'#EF4444';

const PhoneIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.46a16 16 0 0 0 6.29 6.29l1.46-1.46a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const MailIcon  = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const CloseIcon = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const PlusIcon  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const EditIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const EyeIcon   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const EyeOffIcon= () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;

function StatusPill({ status }) {
  const map = { present:['tm-s-green','Present'], leave:['tm-s-amber','On Leave'], absent:['tm-s-red','Absent'] };
  const [cls, label] = map[status]||['tm-s-gray','—'];
  return <span className={`tm-status ${cls}`}>{label}</span>;
}

function SalaryTab({ member, onClose }) {
  const [amount, setAmount] = useState('');
  const [deduction, setDeduction] = useState('');
  const [bonus, setBonus] = useState('');
  const [note, setNote] = useState('');
  const [msg, setMsg] = useState('');

  const base = parseFloat(amount) || 0;
  const ded = parseFloat(deduction) || 0;
  const bon = parseFloat(bonus) || 0;
  const net = base - ded + bon;

  const processSalary = () => {
    if (!base) { setMsg('Enter base salary amount'); return; }
    const entry = {
      category: 'Salaries',
      amount: net,
      date: new Date().toISOString().split('T')[0],
      note: note || ('Salary — ' + member.name + (ded ? ' (deduction ₹'+ded.toLocaleString('en-IN')+')' : '') + (bon ? ' (bonus ₹'+bon.toLocaleString('en-IN')+')' : '')),
      draft: true,
    };
    api.finance.expenses.add(entry)
      .then(() => api.notifications.create({ message: 'Salary draft created for '+member.name+' — ₹'+net.toLocaleString('en-IN')+' (review in Finance → Expenses)', type: 'finance' }))
      .then(() => {
        setMsg('Draft expense created. Review and confirm in Finance → Expenses.');
        setTimeout(()=>{ setMsg(''); onClose(); }, 1800);
      })
      .catch(() => setMsg('Error creating expense entry'));
  };

  return (
    <div className="tm-panel-sec">
      <div className="tm-sec-lbl">Process Salary</div>
      <div className="tm-edit-grp"><label className="tm-lbl">Base salary (₹)</label><input className="tm-inp" type="number" placeholder="0" value={amount} onChange={e=>setAmount(e.target.value)}/></div>
      <div className="tm-edit-grp"><label className="tm-lbl">Deduction (₹, optional)</label><input className="tm-inp" type="number" placeholder="0" value={deduction} onChange={e=>setDeduction(e.target.value)}/></div>
      <div className="tm-edit-grp"><label className="tm-lbl">Bonus (₹, optional)</label><input className="tm-inp" type="number" placeholder="0" value={bonus} onChange={e=>setBonus(e.target.value)}/></div>
      <div className="tm-edit-grp"><label className="tm-lbl">Note (optional)</label><input className="tm-inp" placeholder="e.g. June salary" value={note} onChange={e=>setNote(e.target.value)}/></div>
      <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0',fontSize:13,fontWeight:700,borderTop:'.5px solid rgba(128,128,128,.15)',marginTop:6}}>
        <span style={{opacity:.6}}>Net payable</span>
        <span style={{color:'#F5A623'}}>₹{net.toLocaleString('en-IN')}</span>
      </div>
      {msg && <div style={{background: msg.includes('created')?'#22c55e14':'#ef44441a', color: msg.includes('created')?'#22c55e':'#ef4444', borderRadius:7, fontSize:12, padding:'8px 12px', marginBottom:8}}>{msg}</div>}
      <button className="tm-btn-pri" style={{width:'100%'}} onClick={processSalary}>Create Expense Draft</button>
      <div style={{fontSize:10.5,opacity:.4,marginTop:8,textAlign:'center'}}>This creates a draft in Finance → Expenses. You confirm the final amount there.</div>
    </div>
  );
}

function MemberPanel({ member, theme, onClose, onUpdate, onDelete }) {
  const [tab, setTab] = useState('overview');
  const [form, setForm] = useState({...member});
  const [showPw, setShowPw] = useState(false);
  const [newTask, setNewTask] = useState('');
  const [taskList, setTaskList] = useState(member.taskList || []);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const pct = Math.round((form.tasks.done/form.tasks.total)*100)||0;

  const save = () => { onUpdate({...form, taskList}); onClose(); };

  const addTask = () => {
    if (!newTask.trim()) return;
    setTaskList(p=>[...p,{id:Date.now(),text:newTask,done:false}]);
    setNewTask('');
    setForm(f=>({...f,tasks:{...f.tasks,total:f.tasks.total+1}}));
  };
  const toggleTask = (id) => {
    setTaskList(p=>p.map(t=>t.id===id?{...t,done:!t.done}:t));
    const t = taskList.find(t=>t.id===id);
    if (t) setForm(f=>({...f,tasks:{...f.tasks,done:t.done?f.tasks.done-1:f.tasks.done+1}}));
  };
  const removeTask = (id) => {
    const t = taskList.find(t=>t.id===id);
    setTaskList(p=>p.filter(x=>x.id!==id));
    if (t) setForm(f=>({...f,tasks:{...f.tasks,total:f.tasks.total-1,done:t.done?f.tasks.done-1:f.tasks.done}}));
  };

  return (
    <div className="tm-panel-wrap">
      <div className="tm-overlay" onClick={onClose}/>
      <div className="tm-panel" data-theme={theme}>
        <div className="tm-panel-hd">
          <div className="tm-panel-av">{form.avatar}</div>
          <div className="tm-panel-info">
            <div className="tm-panel-name">{form.name}</div>
            <div className="tm-panel-role">{form.role} · {form.dept}</div>
          </div>
          <button className="tm-icon-btn" onClick={onClose}><CloseIcon/></button>
        </div>

        <div className="tm-panel-acts">
          <a href={`tel:${form.phone}`} className="tm-act-btn"><PhoneIcon/> Call</a>
          <a href={`mailto:${form.email}`} className="tm-act-btn"><MailIcon/> Email</a>
          <button className="tm-act-btn tm-act-edit" onClick={()=>setTab('edit')}><EditIcon/> Edit</button>
        </div>

        <div className="tm-panel-tabs">
          {['overview','account','salary'].map(t=>(
            <button key={t} className={`tm-ptab${tab===t?' active':''}`} onClick={()=>setTab(t)}>
              {t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
          ))}
        </div>

        <div className="tm-panel-body">
          {tab==='overview' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Performance</div>
              <div className="tm-perf-row">
                <div className="tm-perf-track"><div className="tm-perf-fill" style={{width:form.performance+'%',background:perfColor(form.performance)}}/></div>
                <span className="tm-perf-num" style={{color:perfColor(form.performance)}}>{form.performance}%</span>
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Tasks this month</div>
              <div className="tm-task-row">
                <span className="tm-task-num">{form.tasks.done}/{form.tasks.total}</span>
                <span className="tm-task-pct">{pct}% completion</span>
              </div>
              <div className="tm-perf-track" style={{marginTop:6}}><div className="tm-perf-fill" style={{width:pct+'%',background:'#3B82F6'}}/></div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Details</div>
              <div className="tm-kv">
                <span className="tm-k">Phone</span><span className="tm-v">{form.phone}</span>
                <span className="tm-k">Email</span><span className="tm-v">{form.email}</span>
                <span className="tm-k">Joined</span><span className="tm-v">{new Date(form.joinDate).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}</span>
                <span className="tm-k">Leave left</span><span className="tm-v">{form.leaveBalance} days</span>
                <span className="tm-k">Role</span><span className="tm-v" style={{color:'#F5A623',fontWeight:600}}>{form.userRole}</span>
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Today's attendance</div>
              <div className="tm-status-row">
                {['present','leave','absent'].map(s=>(
                  <button key={s} className={`tm-att-btn${form.status===s?' active':''}`}
                    style={form.status===s?{borderColor:s==='present'?'#22C55E':s==='leave'?'#F5A623':'#EF4444'}:{}}
                    onClick={()=>set('status',s)}>
                    {s.charAt(0).toUpperCase()+s.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          </>}

          {tab==='tasks' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Task list</div>
              <div className="tm-task-add-row">
                <input className="tm-task-inp" placeholder="Add a task..." value={newTask} onChange={e=>setNewTask(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addTask()}/>
                <button className="tm-task-add-btn" onClick={addTask}>Add</button>
              </div>
              <div className="tm-task-list">
                {taskList.length===0 && <div className="tm-task-empty">No tasks yet</div>}
                {taskList.map(t=>(
                  <div key={t.id} className={`tm-task-item${t.done?' done':''}`}>
                    <input type="checkbox" checked={t.done} onChange={()=>toggleTask(t.id)} className="tm-task-cb"/>
                    <span className="tm-task-text">{t.text}</span>
                    <button className="tm-task-del" onClick={()=>removeTask(t.id)}>✕</button>
                  </div>
                ))}
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Performance score</div>
              <div className="tm-perf-edit-row">
                <input type="range" min="0" max="100" value={form.performance} onChange={e=>set('performance',parseInt(e.target.value))} className="tm-range"/>
                <span className="tm-perf-num" style={{color:perfColor(form.performance)}}>{form.performance}%</span>
              </div>
            </div>
          </>}

          {tab==='edit' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Basic info</div>
              {[['name','Full name'],['role','Role'],['phone','Phone'],['email','Email']].map(([k,l])=>(
                <div key={k} className="tm-edit-grp"><label className="tm-lbl">{l}</label><input className="tm-inp" value={form[k]} onChange={e=>set(k,e.target.value)}/></div>
              ))}
              <div className="tm-edit-grp"><label className="tm-lbl">Department</label>
                <select className="tm-inp tm-sel" value={form.dept} onChange={e=>set('dept',e.target.value)}>
                  {DEPTS.filter(d=>d!=='All').map(d=><option key={d}>{d}</option>)}
                </select>
              </div>
              <div className="tm-edit-grp"><label className="tm-lbl">Join date</label><input className="tm-inp" type="date" value={form.joinDate} onChange={e=>set('joinDate',e.target.value)}/></div>
              <div className="tm-edit-grp"><label className="tm-lbl">Leave balance (days)</label><input className="tm-inp" type="number" value={form.leaveBalance} onChange={e=>set('leaveBalance',parseInt(e.target.value)||0)}/></div>
            </div>
          </>}

          {tab==='account' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">CRM Access</div>
              <div className="tm-edit-grp"><label className="tm-lbl">Username</label><input className="tm-inp" value={form.username||''} onChange={e=>set('username',e.target.value)}/></div>
              <div className="tm-edit-grp"><label className="tm-lbl">Password</label>
                <div className="tm-pw-wrap">
                  <input className="tm-inp" type={showPw?'text':'password'} value={form.password||''} onChange={e=>set('password',e.target.value)}/>
                  <button className="tm-pw-toggle" onClick={()=>setShowPw(s=>!s)}>{showPw?<EyeOffIcon/>:<EyeIcon/>}</button>
                </div>
              </div>
              <div className="tm-edit-grp"><label className="tm-lbl">Role</label>
                <select className="tm-inp tm-sel" value={form.userRole||'User'} onChange={e=>set('userRole',e.target.value)}>
                  {USER_ROLES.map(r=><option key={r}>{r}</option>)}
                </select>
              </div>
            </div>
          </>}

          {tab==='salary' && <SalaryTab member={form} onClose={onClose}/>}
        </div>

        <div className="tm-panel-ft">
          <button className="tm-btn-danger" onClick={()=>{onDelete(member.id);onClose();}}>Remove</button>
          <button className="tm-btn-pri" style={{flex:1}} onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

function AddModal({ theme, onClose, onAdd }) {
  const [form, setForm] = useState({name:'',role:'',dept:'Sales',phone:'',email:'',joinDate:TODAY,userRole:'User',username:'',password:''});
  const [showPw, setShowPw] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const submit = () => {
    if (!form.name.trim()) return;
    const initials = form.name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
    onAdd({...form,id:Date.now(),avatar:initials,performance:0,status:'present',leaveBalance:15,tasks:{done:0,total:0},taskList:[]});
    onClose();
  };
  return (
    <div className="tm-modal-overlay" onClick={onClose}>
      <div className="tm-modal" data-theme={theme} onClick={e=>e.stopPropagation()}>
        <div className="tm-modal-hd"><span className="tm-modal-title">Add Member</span><button className="tm-icon-btn" onClick={onClose}><CloseIcon/></button></div>
        <div className="tm-modal-body">
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Name *</label><input className="tm-inp" placeholder="Full name" value={form.name} onChange={e=>set('name',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Role</label><input className="tm-inp" list="role-suggestions" placeholder="e.g. Sales Executive" value={form.role} onChange={e=>set('role',e.target.value)}/>
              <datalist id="role-suggestions">{ROLE_SUGGESTIONS.map(r=><option key={r} value={r}/>)}</datalist>
            </div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Department</label>
              <select className="tm-inp tm-sel" value={form.dept} onChange={e=>set('dept',e.target.value)}>
                {DEPTS.filter(d=>d!=='All').map(d=><option key={d}>{d}</option>)}
              </select>
            </div>
            <div className="tm-form-grp"><label className="tm-lbl">Join date</label><input className="tm-inp" type="date" value={form.joinDate} onChange={e=>set('joinDate',e.target.value)}/></div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Phone</label><input className="tm-inp" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e=>set('phone',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Email</label><input className="tm-inp" placeholder="email@company.in" value={form.email} onChange={e=>set('email',e.target.value)}/></div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Username</label><input className="tm-inp" placeholder="username" value={form.username} onChange={e=>set('username',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Password</label>
              <div className="tm-pw-wrap">
                <input className="tm-inp" type={showPw?'text':'password'} placeholder="password" value={form.password} onChange={e=>set('password',e.target.value)}/>
                <button className="tm-pw-toggle" onClick={()=>setShowPw(s=>!s)}>{showPw?<EyeOffIcon/>:<EyeIcon/>}</button>
              </div>
            </div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">CRM Role</label>
              <select className="tm-inp tm-sel" value={form.userRole} onChange={e=>set('userRole',e.target.value)}>
                {USER_ROLES.map(r=><option key={r}>{r}</option>)}
              </select>
            </div>
          </div>
        </div>
        <div className="tm-modal-ft">
          <button className="tm-btn-sec" onClick={onClose}>Cancel</button>
          <button className="tm-btn-pri" onClick={submit}>Add Member</button>
        </div>
      </div>
    </div>
  );
}

export default function Team() {
  const { theme } = useTheme();
  const [members, setMembers] = useState([]);
  React.useEffect(() => {
    api.team.list()
      .then(rows => setMembers(rows.map(m => ({
        ...m, role: m.job_role || '', userRole: m.role, joinDate: m.join_date, leaveBalance: m.leave_balance,
      }))))
      .catch(err => console.error('Failed to load team:', err));
  }, []);

  const [dept, setDept] = useState('All');
  const [selected, setSelected] = useState(null);
  const [showAdd, setShowAdd] = useState(false);

  const [leaveTab, setLeaveTab] = useState(false);
  const [taskDelTab, setTaskDelTab] = useState(false);
  // Task delete requests are now handled directly (employee-side deletes immediately) --
  // this queue is kept empty since there's no longer a pending-approval step.
  const [taskDelReqs, setTaskDelReqs] = useState([]);
  const pendingTaskDels = 0;

  const handleTaskDelete = (reqId, approve) => {
    setTaskDelReqs(prev => prev.map(r => r.id === reqId ? {...r, status: approve ? 'Approved' : 'Declined'} : r));
  };

  const [leaves, setLeaves] = useState([]);
  React.useEffect(() => {
    api.leave.list().then(setLeaves).catch(err => console.error('Failed to load leave requests:', err));
  }, []);
  const pendingLeaves = leaves.filter(l => l.status === 'Pending').length;

  const handleLeave = (id, status) => {
    setLeaves(prev => prev.map(l => l.id === id ? {...l, status} : l));
    api.leave.update(id, status).catch(err => console.error('Failed to update leave request:', err));
  };

  const filtered = dept==='All' ? members : members.filter(m=>m.dept===dept);
  const present  = members.filter(m=>m.status==='present').length;
  const onLeave  = members.filter(m=>m.status==='leave').length;
  const absent   = members.filter(m=>m.status==='absent').length;
  const avgPerf  = Math.round(members.reduce((s,m)=>s+m.performance,0)/members.length);

  const toApiPayload = m => ({
    name: m.name, username: m.username, password: m.password, email: m.email,
    role: m.userRole, jobRole: m.role, dept: m.dept, phone: m.phone, avatar: m.avatar,
    leaveBalance: m.leaveBalance, status: m.status, performance: m.performance,
  });

  const handleUpdate = updated => {
    setMembers(ms=>ms.map(m=>m.id===updated.id?updated:m));
    api.team.update(updated.id, toApiPayload(updated)).catch(err => console.error('Failed to update team member:', err));
  };
  const handleAdd = m => {
    api.team.add(toApiPayload(m))
      .then(created => setMembers(ms=>[
        { ...created, role: created.job_role || '', userRole: created.role, joinDate: created.join_date, leaveBalance: created.leave_balance },
        ...ms.filter(x=>x.id!==m.id),
      ]))
      .catch(err => console.error('Failed to add team member:', err));
    setMembers(ms=>[m,...ms]);
  };
  const handleDelete = id => {
    setMembers(ms=>ms.filter(m=>m.id!==id));
    api.team.remove(id).catch(err => console.error('Failed to delete team member:', err));
  };

  const TopActions = (
    <div className="tm-top-acts">
      <div className="tm-dept-tabs">
        {DEPTS.map(d=>(
          <button key={d} className={`tm-dept-tab${dept===d?' active':''}`} onClick={()=>setDept(d)}>{d}</button>
        ))}
      </div>
      <button className="tm-add-btn" onClick={()=>setShowAdd(true)}><PlusIcon/> Add Member</button>
          {pendingLeaves > 0 && <button className="tm-leave-btn" onClick={()=>setLeaveTab(t=>!t)}>Leave Requests <span className="tm-leave-badge">{pendingLeaves}</span></button>}
          {pendingTaskDels > 0 && <button className="tm-leave-btn" onClick={()=>setTaskDelTab(t=>!t)}>Delete Requests <span className="tm-leave-badge">{pendingTaskDels}</span></button>}
    </div>
  );

  return (
    <div className="tm-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="tm-main">
        <Topbar title="Team" subtitle={`${members.length} members · ${present} present today`} actions={TopActions}/>
        <div className="tm-summary">
          {[
            {label:'Present',         val:present,  total:members.length, color:'#22C55E'},
            {label:'On Leave',        val:onLeave,  total:members.length, color:'#F5A623'},
            {label:'Absent',          val:absent,   total:members.length, color:'#EF4444'},
            {label:'Avg Performance', val:avgPerf+'%', color:perfColor(avgPerf), noBar:true},
          ].map(s=>(
            <div key={s.label} className="tm-sum-card">
              <div className="tm-sum-lbl">{s.label}</div>
              <div className="tm-sum-val" style={{color:s.color}}>{s.val}{!s.noBar&&<span className="tm-sum-total">/{s.total}</span>}</div>
              {!s.noBar&&<div className="tm-sum-bar"><div className="tm-sum-fill" style={{width:(s.val/s.total*100)+'%',background:s.color}}/></div>}
            </div>
          ))}
        </div>
        <div className="tm-grid-wrap">
          <div className="tm-grid">
            {filtered.map(m=>(
              <div key={m.id} className="tm-card" onClick={()=>setSelected(m)}>
                <div className="tm-card-top"><div className="tm-card-av">{m.avatar}</div><StatusPill status={m.status}/></div>
                <div className="tm-card-name">{m.name}</div>
                <div className="tm-card-role">{m.role}</div>
                <div className="tm-card-dept">{m.dept}</div>
                <div className="tm-card-perf-row">
                  <div className="tm-card-perf-track"><div className="tm-card-perf-fill" style={{width:m.performance+'%',background:perfColor(m.performance)}}/></div>
                  <span className="tm-card-perf-num" style={{color:perfColor(m.performance)}}>{m.performance}%</span>
                </div>
                <div className="tm-card-tasks">{m.tasks.done}/{m.tasks.total} tasks done</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {selected && <MemberPanel member={selected} theme={theme} onClose={()=>setSelected(null)} onUpdate={handleUpdate} onDelete={handleDelete}/>}
      {showAdd   && <AddModal theme={theme} onClose={()=>setShowAdd(false)} onAdd={handleAdd}/>}
      {leaveTab && (
        <div className="tm-modal-overlay" onClick={()=>setLeaveTab(false)}>
          <div className="tm-modal" data-theme={theme} style={{width:520,maxHeight:'80vh',overflow:'auto'}} onClick={e=>e.stopPropagation()}>
            <div className="tm-modal-hd"><span className="tm-modal-title">Leave Requests</span><button className="tm-icon-btn" onClick={()=>setLeaveTab(false)}><CloseIcon/></button></div>
            <div className="tm-modal-body">
              {leaves.length===0 ? <div style={{padding:'16px 0',opacity:.4,fontSize:13}}>No leave requests</div> : leaves.map(l=>(
                <div key={l.id} style={{borderBottom:'.5px solid rgba(128,128,128,.15)',padding:'12px 0'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:600,color:'inherit'}}>{l.name}</div>
                      <div style={{fontSize:12,opacity:.6,marginTop:2,color:'inherit'}}>{l.type} · {l.from} → {l.to}</div>
                      <div style={{fontSize:12,opacity:.6,marginTop:2,color:'inherit'}}>{l.reason}</div>
                    </div>
                    <div style={{display:'flex',gap:6,flexShrink:0}}>
                      {l.status==='Pending' ? <>
                        <button onClick={()=>handleLeave(l.id,'Approved')} style={{background:'#22c55e14',border:'.5px solid #22c55e33',borderRadius:6,color:'#22c55e',cursor:'pointer',fontSize:11,fontWeight:600,padding:'4px 10px'}}>Approve</button>
                        <button onClick={()=>handleLeave(l.id,'Declined')} style={{background:'#ef44441a',border:'.5px solid #ef444433',borderRadius:6,color:'#ef4444',cursor:'pointer',fontSize:11,fontWeight:600,padding:'4px 10px'}}>Decline</button>
                      </> : <span style={{fontSize:11,fontWeight:600,color:l.status==='Approved'?'#22c55e':'#ef4444'}}>{l.status}</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
